import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  animations: [
    trigger('slide', [
      state('closed', style({
        transform: 'translateX(100%)',
        opacity: 0
      })),
      state('open', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('closed <=> open', animate('600ms ease-in-out')),
      // transition('closed <=> open', animate('600ms cubic-bezier(0.68, -0.55, 0.27, 1.55)')),

    ]),
  ],
})
export class SliderComponent implements OnChanges {
  @Input() isOpen: boolean = false;
  @Input() width: string = '300px';
  @Input() useDisplay: boolean = true;

  @Output() isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef){}

  visibility: 'open' | 'closed' = 'closed';

  ngOnInit(): void {
    this.visibility = this.isOpen ? 'open' : 'closed';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      this.updateVisibility();
    }
  }
  close(){
    this.isOpen = false;
    this.updateVisibility();
    this.isOpenChange.emit(this.isOpen);
  }
  private updateVisibility(): void {
    this.visibility = this.isOpen ? 'open' : 'closed';
    this.cdr.detectChanges();
  }
}
